"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const lib_1 = require("@brandfree-front/lib");
const StoresUtil_1 = require("../../util/StoresUtil");
let RepresentationNotice = class RepresentationNotice extends react_1.default.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    render() {
        const { translate } = this.translateStore;
        if (this.ssoStore.loaded && this.ssoStore.isDealerWithoutSelectedCustomer) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(lib_1.Notice, { type: "employee" }, translate('dealer.notice')),
                react_1.default.createElement(lib_1.Separator, { color: "invisible", spacing: "xsmall" })));
        }
        return null;
    }
};
RepresentationNotice = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], RepresentationNotice);
exports.default = RepresentationNotice;
